/**
 * Describes the maintenance state of the platform as derived by the server.
 */
export enum MaintenanceState {
  /**
   * No maintenance window is announced or active.
   */
  None = 'None',
  /**
   * A maintenance window is announced but has not started yet.
   */
  Announced = 'Announced',
  /**
   * A maintenance window is currently active.
   */
  Active = 'Active',
}

/**
 * The display names of the maintenance states.
 *
 * Diese Namen sind gleichzeitig die Überschriften des Wartungsbanners: die Oberfläche rendert genau diese
 * Zeichenketten, eine zweite Fassung derselben Überschrift gibt es nicht.
 */
export const maintenanceStateDisplayNames: Record<MaintenanceState, string> = {
  [MaintenanceState.None]: 'Keine Wartung geplant',
  [MaintenanceState.Announced]: 'Geplante Wartung',
  [MaintenanceState.Active]: 'Wartungsmodus aktiv',
};
